import {Inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {filter, switchMap, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import { merge } from 'es-toolkit';
import {ContactsService} from '../contacts/contacts.service';
import {BaseService} from '../../../../shared/src/lib/services/base.service';
import {PaymentsService} from '../../../../shared/src/lib/services/payments.service';

@Injectable({
  providedIn: 'root'
})
export class OneStopService extends BaseService {
  item: any = {};
  meta: any = {};

  permitsService: BaseService;

  constructor(http: HttpClient, private contactsService: ContactsService, private paymentsService: PaymentsService,
              @Inject('environment') private environment) {
    super(`${environment.baseUrl}/onestop/attributes`, http);
    this.permitsService = new BaseService(`${environment.baseUrl}/onestop/permits`, http);
  }

  public loadData(search: any): Observable<any> {

    return this.getList<any>(search).pipe(
      // filter(response => response.results.length > 0),
      switchMap(r => forkJoin({
        item: of(r),
        permit_meta: this.permitsService.loadMetadata()
      })),
      tap(responses => {
        if (responses.item.results[0]) {
          merge(this.item, responses.item.results[0]);
        } else {
          this.item = {};
        }

        merge(this.meta, responses.item.meta);
        this.meta.display_fields = [];
        this.meta.type = 'onestop/attributes';
        this.meta.urlPath = 'onestop';
        this.meta.subItems = ['onestoppermits'];

        this.meta.fields.onestoppermits = this.loadPermitMeta(responses.permit_meta)
      }));
  }

  public loadPermitMeta(permit_meta) {

    permit_meta.type = 'onestop/permits';
    permit_meta.foreign_key_field = 'attributes';
    permit_meta.display_fields = [
      'date_received', 'gepa_ref_number', 'type', 'project_description', 'dpw_permit_number',
      'type_of_sewage', 'hold_reasons', 'fee', 'fee_balance', 'permittee_notified', 'originals_received',
      'originals_signed', 'originals_picked_up'
    ];
    // override hold_reasons meta so displayed as text field
    permit_meta.fields.hold_reasons.max_length = 8000;
    permit_meta.subItems = ['comments', 'contacts', 'attachments', 'agencyattachments', 'supportingattachments', 'review', 'fees', 'payments'];
    permit_meta.listAttachments = true;
    permit_meta.payments = this.paymentsService.meta;
    permit_meta.contacts = {
      type: 'onestop/permits/contacts',
      display_fields: ['relationship_type', 'contact_display_name', 'contact_contact_type', 'contact_email_address', 'contact_phone_number'],
      foreign_key_field: 'permit',
      fields: {
        contact_first_name: {
          get_choices: (s) => this.contactsService.meta.fields.contact_first_name.get_choices(s),
          select_choice: (s, i) => this.contactsService.select_choice(s, i),
          choices: null
        },
        contact_org_name: {
          get_choices: (s) => this.contactsService.meta.fields.contact_org_name.get_choices(s),
          select_choice: (s, i) => this.contactsService.select_choice(s, i),
          choices: null
        }
      }
    };
    permit_meta.fees = {
      type: 'fees',
      verbose_name: 'Fee',
      verbose_name_plural: 'Fees',
      display_fields: ['description', 'amount', 'comments'],
      foreign_key_field: 'record_id',
      refreshProperties: parentItem => {
        this.permitsService.get<any>(parentItem.globalid).subscribe(response => {
          parentItem.fee = response.result.fee;
          parentItem.fee_balance = response.result.fee_balance;
        });
      }
    };
    permit_meta.comments = {
      type: 'onestop/permits/comments',
      foreign_key_field: 'permit',
      display_fields: ['text', 'created_date', 'created_user', 'last_edited_date', 'last_edited_user']
    };
    permit_meta.attachments = {
      type: 'onestop/permits/attach',
      display_fields: ['created_user', 'created_date', 'attachment_type']
    };
    permit_meta.agencyattachments = {
      type: 'onestop/permits/agencyattach',
      display_fields: ['created_user', 'created_date', 'attachment_type']
    };
    permit_meta.supportingattachments = {
      type: 'onestop/permits/supportingattach',
      display_fields: ['created_user', 'created_date', 'attachment_type']
    };
    permit_meta.review = {
      verbose_name_plural: 'Routing/Review',
      verbose_name: 'Review',
      display_fields: ['reviewer', 'status', 'reason', 'order', 'last_edited_date']
    };
    return permit_meta;
  }
}
